import React, {Component} from "react"
import {connect} from 'react-redux';
import Layout from "../../../components/Layout"
import CreateFilters from '../../../components/FilterReports/create_estee';

import "./index.scss"

import {get_all_filial, get_all_stores_user} from "../../../store/actions/rh";

import {
    Grid
} from "carbon-components-react";

import leng from "../../../data";

class Create extends Component {
    componentDidMount() {
        this.props.fetchDataUserStore();
    }

    render() {
        let {data, isLoading} = this.props;
        let rows =
            data?.length > 0
                ? data.map(execution => {
                    return {
                        ...execution,
                        id: execution,
                        label: execution
                    };
                })
                : [];

        return (
            <React.Fragment>
                <Layout>
                    <Grid class="painel" fullWidth>
                        <div className="header-text header-text-report">
                            <h5>{leng.sideBar.intelligentJourney.title}</h5>
                            <h3>Auxiliar Padrão</h3>
                        </div>
                        <div>
                            <CreateFilters data_filial={rows}
                                           isLoading={isLoading} onChange={(e) => {
                                this.handleChange(e)
                            }}/>
                        </div>
                    </Grid>
                </Layout>
            </React.Fragment>
        )
    }
}

const mapStateToProps = ({rh}) => rh;

const mapDispatchToProps = dispatch => ({
    fetchData: () => dispatch(get_all_filial()),
    fetchDataUserStore: () => dispatch(get_all_stores_user()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Create);
